import React from "react";
import { Wrapper } from "../../shared/Wrapper";
import { Choices } from "../../shared/Choices";

/**
 * @param {{
 *  question: string;
 *  description?: string;
 *  value: string;
 *  required?: boolean;
 *  onChange: (value: string) => void;
 *  choices: Array<string>;
 * }} param0
 */
export function QuestionSingleChoice({
  question,
  description,
  value,
  required,
  onChange,
  choices,
}) {
  return (
    <Wrapper title={question} description={description} required={required}>
      <Choices
        options={choices}
        values={value ? [value] : []}
        onChange={(options) => onChange(options?.[0])}
      />
    </Wrapper>
  );
}
